<ds-table
  id="no-element-table"
  class="full-width-ds-table"
  [tableConfig]="myTableConfig"
  [attr.table-empty-title]="'emptyTableTitle' | translate"
  [attr.table-empty-description]="isDocument ? ('emptyDocumentDescription' | translate) : ('emptyTableDescription' | translate)"
  [attr.table-empty-image-url]="emptyImage"
  [attr.table-empty-image-alt]="'emptyTableAltImage' | translate"
    ></ds-table>
